import React from "react";
import { formatCentral, sourceSemantics } from "../presentation";

const words = (value) => String(value || "UNKNOWN").replaceAll("_", " ");

export function MarketHealthGauge({ value }) {
  const score = Number.isFinite(Number(value)) ? Math.max(0, Math.min(100, Number(value))) : null;
  return (
    <div className="msi-health-gauge" aria-label={score === null ? "Market Health unavailable" : `Market Health ${score} out of 100`}>
      <div className="msi-health-track"><span style={{ width: `${score ?? 0}%` }} /></div>
      <small>Structural score from the four core indexes.</small>
    </div>
  );
}

export default function MarketEnvironment({ contract, preview = false }) {
  const env = contract.market_environment;
  const breadth = env.core_index_breadth || {};
  const source = sourceSemantics(contract);
  const daily = contract.structures?.flatMap((row) => row.detail?.guru_msi?.timeframes || []).find((row) => row.timeframe === "DAILY");
  const minutes = daily?.candle_expected_close ? Math.ceil((Date.parse(daily.candle_expected_close) - Date.now()) / 60000) : null;
  return (
    <section className="msi-environment" aria-labelledby="market-environment-title">
      <div className="msi-environment-heading"><div><div className="msi-section-kicker">Private Low Point Capital review</div><h1 id="market-environment-title">MSI Universe</h1></div><span className="msi-asof">{contract.structures?.length || 0} structures · {source.completedClose && contract.freshness_status === "CURRENT" ? "CURRENT" : "STALE"}</span></div>
      <div className="msi-universe-meta"><span><strong>Data as of</strong>{formatCentral(contract.source_as_of)} CT</span><span><strong>Source</strong>{source.sourceKind}</span><span><strong>Session</strong>{words(contract.session_state)}</span><span><strong>Age</strong>{source.ageMinutes} min</span><span><strong>Expected close</strong>{formatCentral(daily?.candle_expected_close)} CT</span><span><strong>Until close</strong>{minutes !== null && minutes >= 0 ? `${minutes} min` : "Closed"}</span></div>
      <div className="msi-environment-grid">
        <div className="msi-health-panel"><span>Market Health</span><strong>{env.health_score ?? "—"}</strong><MarketHealthGauge value={env.health_score} /></div>
        <dl className="msi-environment-facts">
          <div><dt>Market Direction</dt><dd>{words(env.risk_state)}</dd></div>
          <div><dt>Core Index Breadth</dt><dd>{breadth.valid ? `${breadth.up} of ${breadth.valid} UP` : "Unavailable"}</dd></div>
          <div><dt>Volatility</dt><dd>{words(env.vix_regime).replace(" VOL", "")}</dd></div>
          <div><dt>VIX State</dt><dd>{words(env.vix_state)}</dd></div>
        </dl>
      </div>
      <div className="msi-source-line">{preview ? "PREVIEW · NON-LIVE" : `${contract.session_state} · ${source.completedClose ? contract.freshness_status : "STALE — NOT A COMPLETED CLOSE"}`}</div>
    </section>
  );
}
